'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.space = space;
exports.down = down;
exports.up = up;
exports.left = left;
exports.right = right;

var _store = require('../../store');

var _store2 = _interopRequireDefault(_store);

var _actions = require('../../store/actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Copyright 2013-2015, Hudl
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule Shortcuts
 */

function getPlayerState(playerId, store) {
  var _store$getState = store.getState(),
      players = _store$getState.players;

  return players[playerId];
}

function space(playerId, e) {
  var store = _store2.default.storeInstance();
  var player = getPlayerState(playerId, store);
  var event = player.paused ? _actions.play : _actions.pause;

  if (player.queueEnded) {
    store.dispatch((0, _actions.restartPlayables)(playerId));
  } else {
    store.dispatch(event(playerId));
  }

  e.preventDefault();
  e.stopPropagation();
}

function down(playerId) {
  var store = _store2.default.storeInstance();
  var player = getPlayerState(playerId, store);
  var playingIndex = player.playingIndex + 1;

  if (playingIndex === player.playables.size) {
    return;
  }
  store.dispatch((0, _actions.setPlayingIndex)(playerId, playingIndex));
}

function up(playerId) {
  var store = _store2.default.storeInstance();
  var player = getPlayerState(playerId, store);

  if (player.currentTimeMs > 2000 || player.playingIndex === 0) {
    store.dispatch((0, _actions.setCurrentTimeMs)(playerId, 0));
    return;
  }

  store.dispatch((0, _actions.setPlayingIndex)(playerId, player.playingIndex - 1));
}

function left(playerId) {
  var store = _store2.default.storeInstance();
  var player = getPlayerState(playerId, store);

  var timeToMoveTo = player.currentTimeMs - 5000;

  if (timeToMoveTo < 0) {
    timeToMoveTo = 0;
  }

  store.dispatch((0, _actions.setCurrentTimeMs)(playerId, timeToMoveTo));
}

function right(playerId) {
  var store = _store2.default.storeInstance();
  var player = getPlayerState(playerId, store);

  var timeToMoveTo = player.currentTimeMs + 5000;

  if (timeToMoveTo > player.durationMs) {
    timeToMoveTo = player.durationMs - 5000;
  }

  store.dispatch((0, _actions.setCurrentTimeMs)(playerId, timeToMoveTo));
}